// ---------------------------------------------- modules import
import { ThunkAction } from "redux-thunk";

import Actions from "./actions";
import { IUser, UserAction } from "./common";
import { AppState } from "../rootReducer";
import { IThunkExtraArgument } from "../../index";
import firebase from "../../config/fbInit";

const functions = firebase.functions();

// ---------------------------------------------- thunk actions
export const thunkAddUser = (
  user: IUser,
  collectionPath: string
): ThunkAction<void, AppState, IThunkExtraArgument, UserAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
    const addAuth = functions.httpsCallable("addAuth");
    const firebase = getFirebase();
    const { id, password, ...data } = user;

    dispatch(Actions.addBegin());

    firebase
      .firestore()
      .collection(collectionPath)
      .add(data)
      .then(doc =>
        addAuth({ uid: doc.id, email: data.email, password })
          .then(() => dispatch(Actions.addSuccess()))
          .catch(error => {
            dispatch(
              Actions.addError(
                error.message
              )
            )
          }
          )
      )
      .catch(error => dispatch(Actions.addError(error.message)));
  };

export const thunkUpdateUser = (
  user: IUser,
  collectionPath: string
): ThunkAction<void, AppState, IThunkExtraArgument, UserAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
    const firebase = getFirebase();
    const { id, password, ...data } = user;

    dispatch(Actions.updateBegin());

    firebase
      .firestore()
      .collection(collectionPath)
      .doc(id)
      .update(data)
      .then(() => dispatch(Actions.updateSuccess()))
      .catch(error => dispatch(Actions.updateError(error.message)));
  };

export const thunkUpdatePassword = (
  user: IUser,
  password: string
): ThunkAction<void, AppState, IThunkExtraArgument, UserAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
    const updateAuth = functions.httpsCallable("updateAuth");
    const { id } = user;

    dispatch(Actions.updateBegin());

    updateAuth({ id, props: { password } })
      .then(() => dispatch(Actions.updateSuccess()))
      .catch(error =>
        dispatch(
          Actions.updateError(
            error.message
          )
        )
      );
  };

export const thunkDeleteUser = (
  id: string,
  collectionPath: string
): ThunkAction<void, AppState, IThunkExtraArgument, UserAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
    const deleteAuth = functions.httpsCallable("deleteAuth");
    const firebase = getFirebase();

    dispatch(Actions.deleteBegin());

    deleteAuth(id)
      .then(() =>
        firebase
          .firestore()
          .collection(collectionPath)
          .doc(id)
          .delete()
          .then(() => dispatch(Actions.deleteSuccess()))
          .catch(error => dispatch(Actions.deleteError(error.message)))
      )
      .catch(error =>
        dispatch(
          Actions.deleteError(
            error.message
          )
        )
      );
  };
